module.exports = __webpack_public_path__ + "img/image (2).038b0f82.webp";